import { render, staticRenderFns } from "./one-key-access.vue?vue&type=template&id=45c0225b&"
import script from "./one-key-access.vue?vue&type=script&lang=js&"
export * from "./one-key-access.vue?vue&type=script&lang=js&"
import style0 from "../styles/one-key-access.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports